module.exports = __webpack_public_path__ + "img/bannertext.ff3237d.ff3237d1.png";